export function sendLegacyChartTheme(iframe, dark) {
  if (!iframe || !iframe.contentWindow || !iframe.src) return;
  const target = new URL(iframe.src, window.location.href);
  if (target.pathname !== '/stockchart') return; // Never theme third-party embeds.
  iframe.contentWindow.postMessage({ type: 'legacy-chart-theme', dark: Boolean(dark) }, target.origin);
}
